import React, { useState } from 'react';
import { OsbLoader } from '../../../components/common/osb-loader/osb-loader';
import { OsbAlertMessagePopup } from '../../../components/sections/owners-osb/common/osb-alert-message-popup/osb-alert-message-popup';
import { LightPersonalDetailsFlow } from '../../../components/sections/owners-osb/personal-details-step/light-journey/light-personal-details-flow';
import { useOSBStep } from '../../../hooks/owners-osb';
import './personal-details-step-view.scss';

export function PersonalDetailsStepView() {
    const { osbStep } = useOSBStep();
    const [voucherAlertMessage, setVoucherAlertMessage] = useState<string>('');
    const [voucherAlertSuccess, setVoucherAlertSuccess] = useState<boolean>(
        false
    );

    // added this method to handle OsbAlertMessage from light vehicle section to OsbAlertMessage component
    const osbAlertMessagePopup = (message: string, success: boolean) => {
        setVoucherAlertMessage(message);
        setVoucherAlertSuccess(success);
    };

    const closeOsbAlertPopup = () => {
        setVoucherAlertMessage('');
    };
    return (
        <>
            {osbStep.isMainWrapperInitialized ? (
                <>
                    {voucherAlertMessage && (
                        <OsbAlertMessagePopup
                            alertMessage={voucherAlertMessage}
                            alertSuccess={voucherAlertSuccess}
                            closeOsbAlertPopup={closeOsbAlertPopup}
                        />
                    )}
                    <div className="light-personal-details-view-container">
                        <LightPersonalDetailsFlow
                            osbAlertMessagePopup={osbAlertMessagePopup}
                        />
                    </div>
                </>
            ) : (
                <OsbLoader osbEmptyContentHeight={true} />
            )}
        </>
    );
}
